const prefix = '/api/board';
const noticePrefix = '/api/notice';
const faqPrefix = '/api/faq';
const alarmPrefix = '/api/alarm';

const api = {
  getNoticeList: `${noticePrefix}/list`,
  getAlarmList: `${alarmPrefix}/list`,
  getFaqList: `${faqPrefix}/list`,

  getBoardDetail: boardNo => `${prefix}/${boardNo}`,
  getAlarmDetail: alarmNo => `${alarmPrefix}/${alarmNo}`
};

export default {
  ...api
};
